<div style="padding: 20px;">
  <h2 mat-dialog-title style="text-align: center;">Search Maintenance Requests</h2>

  <mat-dialog-content>
    <form [formGroup]="form" class="grid-container">

      <mat-form-field appearance="outline">
        <mat-label>Equipment</mat-label>
        <mat-select formControlName="equipmentMachineId">
          <mat-option [value]="null">All</mat-option>
          @for(e of data.equipmentMachines; track $index) {
          <mat-option [value]="e.id">{{ e.name }}</mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Location</mat-label>
        <mat-select formControlName="locationId">
          <mat-option [value]="null">All</mat-option>
          @for (l of data.locations; track $index) {
          <mat-option [value]="l.id">{{ l.name }}</mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Priority</mat-label>
        <mat-select formControlName="priority">
          <mat-option [value]="null">All</mat-option>
          @for (p of data.priorities; track $index) {
          <mat-option [value]="p">{{ p }}</mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Status</mat-label>
        <mat-select formControlName="statuses" multiple>
          @for (s of data.statusesOptions; track $index) {
          <mat-option [value]="s">{{ s }}</mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="full-width-mobile" style="grid-column: span 2;">
        <mat-label>Date Range</mat-label>
        <mat-date-range-input [rangePicker]="picker">
          <input matStartDate formControlName="startDate" placeholder="Start">
          <input matEndDate formControlName="endDate" placeholder="End">
        </mat-date-range-input>
        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-date-range-picker #picker></mat-date-range-picker>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Operational</mat-label>
        <mat-select formControlName="isOperational">
          <mat-option [value]="null">N/A</mat-option>
          <mat-option [value]="true">Yes</mat-option>
          <mat-option [value]="false">No</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Tagged Out</mat-label>
        <mat-select formControlName="isTaggedOut">
          <mat-option [value]="null">N/A</mat-option>
          <mat-option [value]="true">Yes</mat-option>
          <mat-option [value]="false">No</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>LOTO Followed</mat-label>
        <mat-select formControlName="isLOTOFollowed">
          <mat-option [value]="null">N/A</mat-option>
          <mat-option [value]="true">Yes</mat-option>
          <mat-option [value]="false">No</mat-option>
        </mat-select>
      </mat-form-field>
    </form>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-raised-button (click)="clear()">Clear</button>
    <button mat-stroked-button (click)="close()">Cancel</button>
    <button mat-flat-button color="primary" (click)="apply()">Search</button>
  </mat-dialog-actions>
</div>